/* eslint-disable no-console */
import axios, { CancelTokenSource } from 'axios';

// Function to create a cancellable fetch using Axios
export const fetchWithCancellableToken = async (
  url: string,
  cancelTokenSource: CancelTokenSource
) => {
  try {
    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token
    });
    return response.data;
  } catch (error) {
    const err = error as Error;
    if (axios.isCancel(error)) {
      console.log('Request canceled:', err.message);
    } else {
      console.log('Error occurred:', err.message);
    }
  }
};
